import { VideoPlayerManagerContext } from "@src/utils/VideoPlayerManager";
import { useContext } from "react";

const useVideoManager = () => {
  const videoManager = useContext(VideoPlayerManagerContext);

  if (!videoManager) throw new Error("No provided was found for video manager");

  return videoManager;
};

export default useVideoManager;
